<template>
  <div id="menu">
    <div class="container">
      <div class="row">
        <div :class="['col-md-3 sidebar-col', categoriesVisible ? 'visible' : '']">
          <div class="sidebar">
            <h2 class="section-title">Menu</h2>
            <ul class="menu-categories" v-if="categories">
              <li v-for="category in categories" @click="changeSelectedCategory(category.slug, category.title)" :class="selectedListCategorySlug === category.slug ? 'selected' : ''">
                {{ category.title }}
              </li>
            </ul>
            <div class="top-bg-separator"></div>
          </div>
        </div>
        <div :class="['col-md-9 menu-col', categoriesVisible ? 'not-visible' : '']">
          <div @click="categoriesVisible = !categoriesVisible" class="toggle-categories btn btn-danger btn-xs"><i class="fa fa-bars"></i> Categories</div>
          <section id="selected-menu">
            <h2 class="section-title" v-if="selectedCategoryTitle">{{ selectedCategoryTitle }}</h2>
            <div class="menu-items">
              <div class="row" v-if="products">
                <div v-for="product in products" :class="[selectedCategorySlug === product.category.slug ? 'animated fadeIn' : 'display-none', productsFadeOut ? 'animated fadeOut' : '', 'col-md-12']">
                  <div class="product-item">
                    <div class="image">
                      <img v-if="product.gallery.length" :src="base_url + '/' + product.gallery[0].image_path" :alt="product.title">
                      <img src="../../assets/img/food.png" v-else :alt="product.title">
                    </div>
                    <div class="details">
                      <h3 class="item-title">{{ product.title }}</h3>
                      <p class="item-description">
                        {{ product.description }}
                      </p>
                    </div>

                    <div class="price">
                     <span class="total-price has-discount" v-if="product.discount > 0">
                        <span class="old-price">£ {{ product.price.toFixed(2) }}</span>
                        <span class="discount">£ {{ product.discount.toFixed(2) }}</span>
                      </span>
                      <span class="total-price" v-else>
                      £ {{ product.price.toFixed(2) }}
                    </span>
                    </div>

                    <div class="quantity">
                      <span class="q-add" @click="product.quantity++">+</span>
                      <span class="q-total">{{ product.quantity }}</span>
                      <span class="q-sub" @click="product.quantity > 1 ? product.quantity-- : product.quantity">-</span>
                    </div>

                    <div class="add-to-cart">
                      <b-button class="btn-danger add-to-cart-btn btn-sm" :disabled="!product.availability" @click="addToCart(product.title, product.code, product.gallery.length ? base_url + '/' + product.gallery[0].image_path : '', product.id, product.price, product.discount, product.quantity)">
                        <span class="not-mobile">{{ product.availability ? 'Add to cart' : 'Out of stock' }}</span>
                        <span class="mobile">+</span>
                      </b-button>
                    </div>
                  </div>
                </div>
                <div v-if="products.length === 0 || categories.length === 0" class="text-center">
                  There are no products to display.
                </div>
              </div>
              <div class="row" v-if="!products">
                <div class="col-md-12 text-center pt-2 pb-2">
                  <div class="loader-1"><span></span></div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
<!--    <DiscountPopup popupAfterTime="15"></DiscountPopup>-->
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import env from '../../env.json'
  import DiscountPopup from '../../components/discount-popup.vue'

  export default {
    name: 'homepage',
    computed: {
      ...mapState({
        user: state => state.user,
        location: state => state.location,
        cart: state => state.cart
      })
    },
    data () {
      return {
        products: null,
        categories: [],
        selectedCategorySlug: null,
        selectedCategoryTitle: null,
        selectedListCategorySlug: null,
        productsFadeOut: false,
        base_url: env.base_url,
        categoriesVisible: false
      }
    },
    created () {
      if (this.location) {
        this.$store.dispatch('ListMenu', this.location.id)
          .then(response => {
            this.products = response.products
            this.categories = response.categories

            if (this.categories.length > 0) {
              this.selectedCategorySlug = this.categories[0].slug
              this.selectedCategoryTitle = this.categories[0].title
              this.selectedListCategorySlug = this.categories[0].slug
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    methods: {
      changeSelectedCategory: function (categorySlug, categoryTitle) {
        this.productsFadeOut = true
        this.selectedListCategorySlug = categorySlug
        document.getElementById('mainPanel').scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })

        let kf = this

        kf.categoriesVisible = false

        setTimeout(function () {
          kf.productsFadeOut = false
          kf.selectedCategorySlug = categorySlug
          kf.selectedCategoryTitle = categoryTitle
        }, 500)
      },
      addToCart: function (title, code, image, productId, price, discount, quantity) {
        let cart = this.cart
        let hasProductInCart = false

        cart.forEach((row) => {
          if (row.id === productId && row.type === 'product') {
            row.quantity = row.quantity + quantity
            hasProductInCart = true
          }
        })

        if (!hasProductInCart) {
          this.cart.push({
            type: 'product',
            id: productId,
            title: title,
            code: code,
            image: image,
            price: price,
            discount: discount,
            quantity: quantity
          })
        }

        this.$store.dispatch('UpdateCart', this.cart)
        this.notifyVue('success', `${quantity} of ${title} has been added to your cart.`)
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    },
    components: {
      DiscountPopup
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// menu.vue?7bb1c3ef